import { render, staticRenderFns } from "./CustomizeTable.vue?vue&type=template&id=6f4093ee&"
import script from "./CustomizeTable.vue?vue&type=script&lang=js&"
export * from "./CustomizeTable.vue?vue&type=script&lang=js&"
import style0 from "./CustomizeTable.vue?vue&type=style&index=0&id=6f4093ee&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports